import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

///import AA_Page from "./pages/AA_Page";

import Profile from "./pages/Profile";
///import Orders from "./pages/Orders";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";
import LoginWithOtp from "./pages/LoginWithOtp";
import Logout from "./pages/Logout";
import LoginDirectPage from "./pages/LoginDirectPage";
import Dashboard from "./pages/Dashboard";
import StudyMaterials from "./pages/StudyMaterialsV3";
import Report from "./pages/Report";
import Analytics from "./pages/Analytics";
import AnalyticLearningSelfTest from "./pages/AnalyticLearningSelfTest";
import AnalyticsSelfTest from "./pages/AnalyticsSelfTest";
import SelfAssessor from "./pages/SelfAssessorV2";
import SelectMockTest from "./pages/SelectMockTest";
import SelectTopicTest from "./pages/SelectTopicTestV2";
import SelectClassTest from "./pages/SelectClassTest";
///import TestSimulator from "./pages/TestSimulator";
import TestViewDetails from "./pages/TestViewDetails";
import SelectCoursePage from "./pages/SelectCoursePage";
import SelectCoursePageFree from "./pages/SelectCoursePageFree";
import ValidityPage from "./pages/ValidityPage";
import Payments from "./pages/Payments";
import PGResponse from "./pages/PGResponse";
import PGCancelled from "./pages/PGCancelled";
import InAppPayment from "./pages/InAppPayment";
import LiveClass from "./pages/LiveClass";
import JitsiMeeting from "./pages/JitsiMeeting";
import Feedback from "./pages/Feedback";
import TestSimulatorSubjective from "./pages/TestSimulatorSubjective";
import TestSimulatorGuest from "./pages/TestSimulatorGuest";
import TestSimulatorGuestBegin from "./pages/TestSimulatorGuestBegin";
import TestViewSubjective from "./pages/TestViewSubjective";
import { useDispatch } from "react-redux";

import TextToSpeech from "./pages/TextToSpeech";
import { useSelector } from "react-redux";
import StudentDemo from "./components/StudentDemo";
import { setPopup } from "./store/popup.actions";
import NewTutorialButton from "./components/StudentTutorial/NewStudentTutorial";
// const getBasename = () => {
//   ///return '/'+process.env.PUBLIC_URL.split('/').pop();
//   ///return "/reacteasetolearn";
//   return "/student";
// };

function App() {
  // Selectors
  const ftueModal = useSelector((state) => state?.popup1);
  const showDemo = useSelector((state) => state?.demo);

  // Dispatch
  const dispatch = useDispatch();
  const ftue = JSON.parse(localStorage.getItem("ftue"));
  const etlStudentObj = JSON.parse(localStorage.getItem("etlStudentObj"));
  if (etlStudentObj?.firstTimeUser === 1 && !ftue) {
    etlStudentObj.firstTimeUser = 0;
    localStorage.setItem("etlStudentObj", JSON.stringify(etlStudentObj));
    dispatch(setPopup(true));
  }

  return (
    <>
      <Router basename={"/student"}>
        <div>
          {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
          <Switch>
            {/* <Route exact path="/samplepage" component={AA_Page} /> */}

            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/report" component={Report} />

            <Route
              exact
              path="/testsimulator"
              component={TestSimulatorSubjective}
            />
            <Route
              exact
              path="/guest-testbegin"
              component={TestSimulatorGuestBegin}
            />
            <Route
              exact
              path="/guest-testsimulator"
              component={TestSimulatorGuest}
            />
            {/* <Route exact path="/testsimulator-subjective" component={TestSimulatorSubjective} /> */}
            {/* <Route exact path="/testsimulator" component={TestSimulator} /> */}
            <Route exact path="/testview" component={TestViewDetails} />
            <Route
              exact
              path="/testviewsubjective"
              component={TestViewSubjective}
            />

            <Route exact path="/analytics" component={Analytics} />
            <Route exact path="/testanalytics" component={AnalyticsSelfTest} />
            <Route
              exact
              path="/learning-testanalytics"
              component={AnalyticLearningSelfTest}
            />
            <Route exact path="/selfassessor" component={SelfAssessor} />
            <Route exact path="/studymaterials" component={StudyMaterials} />
            <Route exact path="/selecttopictest" component={SelectTopicTest} />
            <Route exact path="/selectmocktest" component={SelectMockTest} />
            <Route exact path="/selectclasstest" component={SelectClassTest} />

            <Route exact path="/payments" component={Payments} />
            <Route exact path="/profile" component={Profile} />
            <Route exact path="/selectcourse" component={SelectCoursePage} />
            <Route
              exact
              path="/selectyourcourse"
              component={SelectCoursePageFree}
            />
            <Route exact path="/validity" component={ValidityPage} />
            <Route exact path="/pgresponse" component={PGResponse} />
            <Route exact path="/pgcancelled" component={PGCancelled} />
            <Route exact path="/feedback" component={Feedback} />
            <Route exact path="/liveclass" component={LiveClass} />
            <Route exact path="/jitsimeeting" component={JitsiMeeting} />
            <Route exact path="/inapppayment" component={InAppPayment} />

            <Route exact path="/texttospeech" component={TextToSpeech} />

            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <Route exact path="/logindirect" component={LoginDirectPage} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/loginwithotp" component={LoginWithOtp} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/" component={Login} />
          </Switch>
        </div>
      </Router>

      {showDemo?.demo?.demo && <StudentDemo />}
      {ftueModal ? <NewTutorialButton /> : <></>}
    </>
  );
}

export default App;
